import React from "react";
import { Typography } from "@mui/material";

export default function ProductName({ product }) {
  if (!product || !product.item_name) return null;


  return (
    <Typography variant="h6" gutterBottom>
      SKU - {product.sku}
    </Typography>
  );
}
